import { BpPageContext } from './page.model';
import { EpJsConfig } from '../../../models/config.model';
import {
  BpMetricsCommonMetricsTrack,
  BpMetricsTrackBrowserCtx,
  BpMetricsTrackingInfo
} from '@ads-ep/api-metrics';

export class BpMetricsContext implements BpMetricsCommonMetricsTrack {
  apiKey: string;
  internalEventName: string;
  browserCtx: BpMetricsTrackBrowserCtx;
  trackingInfo: BpMetricsTrackingInfo;
  timestamp = new Date();

  constructor(
    config?: EpJsConfig,
    trackingInfo: BpMetricsTrackingInfo = {}
  ) {
    if (config) {
      this.apiKey = config.apiKey;
      this.browserCtx = {
        library: {
          name: 'mp-js-lib',
          version: config.sdkVersion
        },
        userAgent: navigator.userAgent,
        page: new BpPageContext()
      };
      this.trackingInfo = trackingInfo;
    }
  }
}
